import {prefix} from "app/config/routes/pp/_cfg";

export const routePP = {
    'pp': `${prefix}`,
    'pp.dashboard': `${prefix}`,

    //
    'pp.training': `${prefix}/training`,
}